import React, {useState, useEffect} from 'react'
import { Button, Grid } from '@material-ui/core'
import useStyles from './styles'
import {getStartIcon, getEndIcon} from './utils'
import {isNonEmpty} from '../../../shared/utils'

export default function Banner(props) {

    const classes = useStyles(props)
    const {
            message=null, 
            position='center',
            severity='error',
            endIcon=getEndIcon(),
            ...wrapperprops
        } = props

    const startIcon = props.startIcon || getStartIcon(severity)

    const [state, setState] = useState({message, open: isNonEmpty(message)})

    const clearState = () => {
        setState({message: null, open: false})
    }

    useEffect(() => {
      setState({ message: props.message, open: isNonEmpty(props.message) });
    }, [props.message]);

    return(
        <div {...wrapperprops} style={{...wrapperprops.style, width: '100%'}} >
            { state.open && message &&
                <Grid container justify={position} onClick={clearState}>
                    <Grid item xs={12}>
                        <Button 
                            className={classes.button}
                            startIcon={startIcon}
                            endIcon={endIcon}
                            fullWidth
                        >
                            <div className={classes.message} >
                                <span>{message}</span>
                            </div>
                        </Button>
                    </Grid>
                </Grid>
            }
        </div>
    )
}